import StarterKit from '@tiptap/starter-kit'
import TextAlign from '@tiptap/extension-text-align'
import Underline from '@tiptap/extension-underline'
import { FontSize, TextStyle } from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import FontFamily from '@tiptap/extension-font-family'
import Highlight from '@tiptap/extension-highlight'
import { Variable } from '../components/tiptap/VariableExtension'
import { EmailLink } from './emailLink'
import type { Extensions } from '@tiptap/core'

export function createEmailEditorExtensions(options?: { disableGapcursor?: boolean }): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4, 5, 6] },
      // Disable link and underline from StarterKit to use custom configurations below
      link: false,
      underline: false,
      ...(options?.disableGapcursor ? { gapcursor: false } : {})
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph']
    }),
    Underline,
    EmailLink.configure({ openOnClick: false }),
    TextStyle,
    Color,
    FontFamily,
    FontSize,
    Highlight.configure({
      multicolor: true
    }),
    Variable
  ]
}

/**
 * Extensions for rendering TipTap content to HTML (e.g. in preview mode).
 * Matches the editor extensions but without interactive settings.
 */
export function createEmailRenderExtensions(): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4, 5, 6] },
      link: false,
      underline: false
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph']
    }),
    Underline,
    EmailLink.configure({ openOnClick: false }),
    TextStyle,
    Color,
    FontFamily,
    FontSize,
    Highlight.configure({ multicolor: true }),
    Variable
  ]
}
